import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Actions
import actions from '../../../actions/newsletter';

// Component
import NewsletterForm from './NewsletterForm';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  newsletterData: PropTypes.object.isRequired,
  getNewsletter: PropTypes.func.isRequired,
};
const contextTypes = {
  customStore: PropTypes.object,
  t: PropTypes.func,
};

class Newsletter extends Component {
  constructor(props, { customStore, initialRender }) {
    super(props);
    if (initialRender) {
      props.getNewsletter(customStore);
    }
  }

  componentDidMount() {
    const { getNewsletter, newsletterData } = this.props;
    const { customStore } = this.context;
    if (Object.keys(newsletterData).length === 0) {
      getNewsletter(customStore);
    }
  }
  render() {
    const {
      newsletterData: {
        title,
        description = '',
        layout = 'dark',
        form_action_url: formActionUrl,
        form_goto: formGoto,
      },
    } = this.props;
    return (
      <section className={`newsletter newsletter--${layout}`}>
        <div className="newsletter__wrapper">
          { title && title.title &&
          <h1 className="newsletter__main-title">
            {title.title}
            {title.subtitle &&
            <small>{title.subtitle}</small>
            }
          </h1>
          }
          { description &&
          <div className="newsletter__description">
            <p>{description}</p>
          </div>
          }
          {formActionUrl &&
          <NewsletterForm
            url={formActionUrl}
            goto={formGoto}
          />
          }
        </div>
      </section>
    );
  }
}

Newsletter.propTypes = propTypes;
Newsletter.contextTypes = contextTypes;

function mapStateToProps(state) {
  return {
    newsletterData: state.newsletter.newsletterData,
  };
}

export default withRouter(connect(mapStateToProps, actions)(Newsletter));



// WEBPACK FOOTER //
// ./src/app/components/layouts/newsletter/Newsletter.js